import React, { useRef, useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import gsap from 'gsap';

interface TransitionOverlayProps {
  destination: string | null;
  onTransitionEnd: () => void;
}

export const TransitionOverlay: React.FC<TransitionOverlayProps> = ({ destination, onTransitionEnd }) => {
  const overlayRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (destination) {
      const overlay = overlayRef.current;
      if (!overlay) return;

      // Cubrir pantalla de izquierda a derecha
      gsap.to(overlay,{
        x: '0%',
        duration: 0.6,
        ease: 'power2.inOut',
        onComplete: () => {
            navigate(destination);

          // Salir hacia la derecha
          gsap.to(overlay, {
            x: '100%',
            duration: 0.6,
            ease: 'power2.inOut',
            onComplete: () => {
              // Resetear overlay
              gsap.set(overlay, { x: '-100%' });
              onTransitionEnd();
            }
          });
        }
      });
    }
  }, [destination, navigate, onTransitionEnd]);

  return(
   <div ref={overlayRef} className="fixed top-0 left-0 w-screen h-screen z-50 bg-[#f7cf48]" style={{ transform: "translate(-100%,0)"}}></div>
  )  
};